module.exports = __webpack_public_path__ + "media/images/vedett_allatok/Vedett-blokk_0000__-191548f93f063f9365cc9f1e7ad7f207.png";